import React from 'react';
import './Toggle.scoped.scss';

interface IProps {
  name: string;
  value: string;
  onClick: any;
  checked: boolean;
}

const Toggle: React.FC<IProps> = ({ name, checked, onClick, value }) => {
  return (
    <div>
      <input
        type="checkbox"
        id={name}
        value={value}
        checked={checked}
        onClick={() => {
          onClick(value);
        }}
      />
      <label htmlFor={name}>
        <span></span>
      </label>
    </div>
  );
};

export default Toggle;
